import React, {
  useState,
  useMemo,
  useEffect,
  useCallback,
  useContext,
} from "react";
import _ from "lodash";
import { useNavigate, generatePath } from "react-router-dom";
import { Dropdown, Menu, Space } from "antd";
import { ROUTES_PATH } from "routes";
// Icons
import {
  MenuOutlined,
  CopyOutlined,
  ImportOutlined,
  SwapOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
// Helpers

import { prepareBody } from "hooks/useTeamRun";
// API
import {
  archiveOption,
  archiveOptions,
  duplicateTeamRunAndMakeLive,
  duplicateTeamRunAndRemoveLive,
  handlePullToPricerClickTeamRun,
  highLightAPI,
  makeActiveInActiveAPI,
  setColorForRow,
  triggerSingleAPI,
} from "api/teamRunApi";
// Context
import { TeamRunContext } from "contexts/TeamRunContext";
// Style
import { GlobalContext } from "contexts/GlobalContext";
import classnames from "classnames";
import {
  extractCopyShortHandForSummaryRows,
  isTrader,
  resolveRowsForMenuAction,
  status200,
  updateTeamRunData,
} from "helpers/generalHelper";
import { handleCopyShortHand, toast } from "helpers/generalHelper";
import { TEAMRUN_DATAfun } from "helpers/teamRunHelper";
import { ACTION_BUTTONS_NAME } from "constants/generalActionButtons";
import {
  ACTION_COLUMN_MENU_ITEMS,
  appendTeamRunLiveDuplicateMenuItems,
  getAllMenuItemsPossibility,
  TEAM_RUN_COLORS_STATE,
} from "constants/teamRun";
import {
  ACTIONS,
  CATEGORIES,
  COMPONENT_NAMES,
  CONTEXTS,
  EVENT_NAMES,
  sendEvent,
} from "helpers/googleAnalyticsHelper";

const ActionColumn = (props) => {
  const navigate = useNavigate();
  const {
    state: {
      selectedRows,
      tradePopup_data,
      bidAskPopup_data,
      teamRunData,
      contextMenuAction,
      teamrunRefAgGrid,
    },
    setTeamRunData,
    setTradePopupData,
    setBidAskPopupData,
    setAdditionalPopupData,
    setBlastPopupData,
    setContextMenuAction,
    openPayoutModal,
  } = useContext(TeamRunContext);
  const {
    globalState: { dark_Theme, loginInfo },
  } = useContext(GlobalContext);

  const [menuItemsClicked, setMenuItemsClicked] = useState("");
  // const [isUpdateOptionClicked, setIsUpdateOptionClicked] = useState(false);
  // const [isPushOptionClicked, setIsPushOptionClicked] = useState(false);
  const [menuItemsData, setMenuItemsData] = useState(ACTION_COLUMN_MENU_ITEMS);
  const [rowData, setRowData] = useState({});
  // const [isUpdateBidOrAskActive, setIsUpdateBidOrAskActive] = useState("");

  const colorArray = TEAMRUN_DATAfun()?.[TEAM_RUN_COLORS_STATE];
  const canViewChat = useMemo(
    () =>
      (loginInfo?.authorized_permissions ?? []).includes("View-Chat"),
    [loginInfo?.authorized_permissions]
  );

  useEffect(() => {
    if (_.isEmpty(props.data)) return;

    setRowData(props.data);
  }, [props.data]);

  // Bulk is only offered when the row the menu was opened from is part of the selection.
  const selectedRowsLength = useMemo(() => {
    const productSelection = selectedRows?.[props.data?.product_title] ?? [];
    return (
      productSelection.length > 1 &&
      productSelection.includes(props.data?.summary_id)
    );
  }, [props.data, selectedRows, teamRunData]);

  const idsForMenuAction = useCallback(
    (data) =>
      resolveRowsForMenuAction(
        data?.summary_id,
        selectedRows?.[data?.product_title]
      ),
    [selectedRows]
  );

  useEffect(() => {
    let activeInactive = [
      {
        id: "make-active",
        key: ACTION_BUTTONS_NAME.MAKE_ACTIVE.key,
        label: ACTION_BUTTONS_NAME.MAKE_ACTIVE.label,
        icon: <PlusCircleOutlined />,
        index: 12,
      },
      {
        id: "make-in-active",
        key: ACTION_BUTTONS_NAME.MAKE_IN_ACTIVE.key,
        label: ACTION_BUTTONS_NAME.MAKE_IN_ACTIVE.label,
        icon: <MinusCircleOutlined />,
        index: 13,
      },
    ];

    setMenuItemsData(
      selectedRowsLength
        ? [
            ...returnSelectedDropDown().filter(
              (item) =>
                item.key === "archive" ||
                item.key === ACTION_BUTTONS_NAME.COPY_SHORTHAND_NO_VOLS.key ||
                item.key ===
                  ACTION_BUTTONS_NAME.COPY_SHORTHAND_NO_VOL_PREM.key ||
                item.key === ACTION_BUTTONS_NAME.COPY_SHORTHAND_DELTA.key ||
                item.key === "copy_shorthand" ||
                item.key === ACTION_BUTTONS_NAME.PULL_TO_PRICER.key ||
                item.key === ACTION_BUTTONS_NAME.COLOR
            ),
            ...activeInactive,
          ]
        : menuItemsData
    );
  }, [selectedRowsLength, props.data, teamRunData]);

  useEffect(() => {
    if (
      !contextMenuAction ||
      contextMenuAction.productTitle !== props.data?.product_title ||
      contextMenuAction.rowData?.id !== props.data?.id ||
      !contextMenuAction.menuKey
    ) {
      return;
    }
    const menuKey = contextMenuAction.menuKey;
    const rowDataFromContext = contextMenuAction.rowData;
    setContextMenuAction(null);
    handleMenuItemClick(menuKey, rowDataFromContext);
  }, [contextMenuAction]);

  useEffect(() => {
    if (teamRunData) {
      if (
        tradePopup_data.isTradeItemClicked &&
        props.data.id === tradePopup_data.data.id
      ) {
        let updatedTeamRunData =
          teamRunData[tradePopup_data.data.product_title] &&
          teamRunData[tradePopup_data.data.product_title].find(
            (item) => item.id === tradePopup_data.data.id
          );
        let teamRunTrade_data = {
          ...tradePopup_data,
          data: updatedTeamRunData,
        };
        // setTradePopupData(teamRunTrade_data);
      }

      if (
        bidAskPopup_data.isOpen &&
        props.data?.id === bidAskPopup_data.data?.id
      ) {
        let updatedBidAskData =
          teamRunData[bidAskPopup_data.data.product_title] &&
          teamRunData[bidAskPopup_data.data.product_title].find(
            (item) => item.id === bidAskPopup_data.data.id
          );
        let teamRunBidAsk_data = {
          ...bidAskPopup_data,
          data: updatedBidAskData,
        };
        // setBidAskPopupData(teamRunBidAsk_data);
      }

      let updatedRowData = teamRunData[props.data.product_title]?.find(
        (row) => row.id === props.data.id
      );
      setRowData(updatedRowData);
    }
  }, [teamRunData, props.data]);

  const dynamicList = useMemo(() => {
    const {
      HIGH_LIGHT_ACTIVE,
      HIGH_LIGHT_IN_ACTIVE,
      UN_HIGH_LIGHT_IN_ACTIVE,
      UN_HIGH_LIGHT_ACTIVE,
    } = getAllMenuItemsPossibility();

    return {
      HIGH_LIGHT_ACTIVE,
      HIGH_LIGHT_IN_ACTIVE,
      UN_HIGH_LIGHT_IN_ACTIVE,
      UN_HIGH_LIGHT_ACTIVE,
    };
  }, [props.data]);

  const triggerSingleAPIFunc = (productId) => {
    triggerSingleAPI(productId)
      .then(({ data }) => {
        const formattedData = prepareBody(data);
        setTeamRunData(formattedData);
      })
      .catch((err) => console.log({ err }));
  };

  const openBidAskPopupForRow = (row, { discardOnCancel = false } = {}) => {
    const productTitle = row?.product_title ?? props.data?.product_title;
    const updatedTeamRunData =
      teamRunData[productTitle]?.find((item) => item.id === row?.id) ?? row;
    setBidAskPopupData({
      isOpen: true,
      isUpdateBidModalVisible: true,
      keyItem: ACTION_BUTTONS_NAME.UPDATE_BID_ASK.key,
      selectedModal: ACTION_BUTTONS_NAME.UPDATE_BID_ASK.key,
      triggerSingleAPIFunc: triggerSingleAPIFunc,
      data: updatedTeamRunData,
      discardOnCancel,
    });
  };

  const setDataForBidAndAskPopup = () => {
    openBidAskPopupForRow(props.data);
  };

  const handleDuplicateTeamRunLive = async (mode, sourceRow) => {
    const summaryId = sourceRow?.summary_id;
    if (summaryId == null) return;

    const request =
      mode === "make"
        ? duplicateTeamRunAndMakeLive
        : duplicateTeamRunAndRemoveLive;

    sendEvent({
      category: CATEGORIES.TEAM_RUN,
      context: CONTEXTS.TEAM_RUN_ACTION_MENU,
      action: ACTIONS.CLICK,
      eventName:
        mode === "make"
          ? EVENT_NAMES.TEAM_RUN_DUPLICATE_AND_MAKE_LIVE_MENU
          : EVENT_NAMES.TEAM_RUN_DUPLICATE_AND_REMOVE_LIVE_MENU,
    });

    try {
      const res = await request(summaryId);
      if (!status200(res)) return;

      toast(res?.data?.message, "success");
      const payload = res?.data?.data ?? {};
      const { team_run_row_id: teamRunRowId, summary_id: newSummaryId } =
        payload;

      const refreshed = await triggerSingleAPI(sourceRow.product_id);
      const formattedData = prepareBody(refreshed?.data);
      setTeamRunData(formattedData);

      const productTitle = sourceRow.product_title;
      const newRow = formattedData[productTitle]?.find(
        (item) =>
          item.id === teamRunRowId ||
          (newSummaryId != null && item.summary_id === newSummaryId)
      );

      if (newRow) {
        // A2-1558: both duplicate actions open an empty quote book; closing without
        // a successful store-batch save discards the new row.
        openBidAskPopupForRow(newRow, { discardOnCancel: true });
      }
    } catch {
      // 422 and other errors are surfaced by the API client; table refresh is unnecessary.
    }
  };

  const returnSelectedDropDown = () => {
    if (rowData) {
      let items;
      if (rowData["is_active"] && rowData["is_highlighted"]) {
        items = dynamicList.UN_HIGH_LIGHT_IN_ACTIVE;
      } else if (!rowData["is_active"] && !rowData["is_highlighted"]) {
        items = dynamicList.HIGH_LIGHT_ACTIVE;
      } else if (!rowData["is_active"] && rowData["is_highlighted"]) {
        items = dynamicList.UN_HIGH_LIGHT_ACTIVE;
      } else if (rowData["is_active"] && !rowData["is_highlighted"]) {
        items = dynamicList.HIGH_LIGHT_IN_ACTIVE;
      } else {
        items = menuItemsData;
      }
      return appendTeamRunLiveDuplicateMenuItems(items, rowData);
    }
    return [];
  };

  const handleResponse = (res, itemClicked) => {
    if (status200(res)) {
      if (teamrunRefAgGrid[rowData.product_title]) {
        setRowData(res.data.data[0]);
        let updatedData = updateTeamRunData(
          rowData.product_title,
          res.data.data,
          teamrunRefAgGrid
        );
        setTeamRunData({
          ...teamRunData,
          [rowData.product_title]: updatedData,
        });
        if (itemClicked === ACTION_BUTTONS_NAME.UN_HIGHLIGHT.key) {
          !!rowData["is_active"]
            ? setMenuItemsData(dynamicList.HIGH_LIGHT_IN_ACTIVE)
            : setMenuItemsData(dynamicList.HIGH_LIGHT_ACTIVE);
        } else if (itemClicked === ACTION_BUTTONS_NAME.HIGHLIGHT.key) {
          !!rowData["is_active"]
            ? setMenuItemsData(dynamicList.UN_HIGH_LIGHT_IN_ACTIVE)
            : setMenuItemsData(dynamicList.UN_HIGH_LIGHT_ACTIVE);
        } else if (itemClicked === ACTION_BUTTONS_NAME.MAKE_IN_ACTIVE.key) {
          !!rowData["is_highlighted"]
            ? setMenuItemsData(dynamicList.UN_HIGH_LIGHT_ACTIVE)
            : setMenuItemsData(dynamicList.HIGH_LIGHT_ACTIVE);
        } else if (itemClicked === ACTION_BUTTONS_NAME.MAKE_ACTIVE.key) {
          !!rowData["is_highlighted"]
            ? setMenuItemsData(dynamicList.UN_HIGH_LIGHT_IN_ACTIVE)
            : setMenuItemsData(dynamicList.HIGH_LIGHT_IN_ACTIVE);
        }
      }
    } else {
      triggerSingleAPIFunc(rowData.product_id);
    }
  };

  const handleMenuItemClickPartTwo = async (itemClicked, dataOverride) => {
    const dataToUse = dataOverride ?? rowData;
    if (itemClicked === ACTION_BUTTONS_NAME.UN_HIGHLIGHT.key) {
      sendEvent({
        category: CATEGORIES.TEAM_RUN,
        context: CONTEXTS.TEAM_RUN_ACTION_MENU,
        action: ACTIONS.CLICK,
        eventName: EVENT_NAMES.TEAM_RUN_UNHIGHLIGHT_MENU,
      });
      highLightAPI(dataToUse.summary_id)
        .then((res) => {
          handleResponse(res, itemClicked);
        })
        .catch((err) => {
          console.log("Error ", err);
          triggerSingleAPIFunc(dataToUse.product_id);
        });
    }

    if (itemClicked === ACTION_BUTTONS_NAME.HIGHLIGHT.key) {
      sendEvent({
        category: CATEGORIES.TEAM_RUN,
        context: CONTEXTS.TEAM_RUN_ACTION_MENU,
        action: ACTIONS.CLICK,
        eventName: EVENT_NAMES.TEAM_RUN_HIGHLIGHT_MENU,
      });
      highLightAPI(dataToUse.summary_id)
        .then((res) => {
          handleResponse(res, itemClicked);
        })
        .catch((err) => {
          console.log("Error ", err);
          triggerSingleAPIFunc(dataToUse.product_id);
        });
    }

    if (itemClicked === ACTION_BUTTONS_NAME.MAKE_IN_ACTIVE.key) {
      sendEvent({
        category: CATEGORIES.TEAM_RUN,
        context: CONTEXTS.TEAM_RUN_ACTION_MENU,
        action: ACTIONS.CLICK,
        eventName: EVENT_NAMES.TEAM_RUN_MAKE_INACTIVE_MENU,
      });
      makeActiveInActiveAPI(idsForMenuAction(dataToUse), 0)
        .then((res) => {
          handleResponse(res, itemClicked);
        })
        .catch((err) => {
          console.log("Error ", err);
          triggerSingleAPIFunc(rowData.product_id);
        });
    }

    if (itemClicked === ACTION_BUTTONS_NAME.MAKE_ACTIVE.key) {
      sendEvent({
        category: CATEGORIES.TEAM_RUN,
        context: CONTEXTS.TEAM_RUN_ACTION_MENU,
        action: ACTIONS.CLICK,
        eventName: EVENT_NAMES.TEAM_RUN_MAKE_ACTIVE_MENU,
      });
      makeActiveInActiveAPI(idsForMenuAction(dataToUse), 1)
        .then((res) => {
          handleResponse(res, itemClicked);
        })
        .catch((err) => {
          console.log("Error ", err);
          triggerSingleAPIFunc(dataToUse.product_id);
        });
    }

    if (itemClicked.includes("#")) {
      sendEvent({
        category: CATEGORIES.TEAM_RUN,
        context: CONTEXTS.TEAM_RUN_ACTION_MENU,
        action: ACTIONS.CLICK,
        eventName: EVENT_NAMES.TEAM_RUN_CHANGE_ROW_COLOR_MENU,
        extraParams: { color: itemClicked },
      });
      const filterColor = colorArray.find(
        (color) => color.hex_code === itemClicked
      );
      setColorForRow({
        summary_ids: idsForMenuAction(dataToUse),
        color_id: filterColor.id,
      })
        .then((res) => {
          handleResponse(res, itemClicked);
        })
        .catch((err) => {
          console.log("Error ", err);
          triggerSingleAPIFunc(dataToUse.product_id);
        });
    }
    if (itemClicked === ACTION_BUTTONS_NAME.REMOVE_COLOR.key) {
      sendEvent({
        category: CATEGORIES.TEAM_RUN,
        context: CONTEXTS.TEAM_RUN_ACTION_MENU,
        action: ACTIONS.CLICK,
        eventName: EVENT_NAMES.TEAM_RUN_CHANGE_ROW_COLOR_MENU,
        extraParams: { color: "remove" },
      });
      setColorForRow({
        summary_ids: idsForMenuAction(dataToUse),
        is_remove: 1,
      })
        .then((res) => {
          handleResponse(res, itemClicked);
        })
        .catch((err) => {
          console.log("Error ", err);
          triggerSingleAPIFunc(dataToUse.product_id);
        });
    }
    if (itemClicked === ACTION_BUTTONS_NAME.PAYOUT.key) {
      sendEvent({
        category: CATEGORIES.TEAM_RUN,
        context: CONTEXTS.TEAM_RUN_ACTION_MENU,
        action: ACTIONS.CLICK,
        eventName: EVENT_NAMES.TEAM_RUN_PAYOUT_MENU,
      });
      if (dataToUse?.summary_id != null) {
        openPayoutModal(dataToUse.summary_id);
      }
      return;
    }
  };

  const handleMenuItemClick = useCallback(
    async (itemClicked, rowDataOverride) => {
      const data = rowDataOverride ?? rowData;
      if (itemClicked === ACTION_BUTTONS_NAME.COPY_SHORTHAND.key) {
        extractCopyShortHandForSummaryRows(props);
        sendEvent({
          category: CATEGORIES.TEAM_RUN,
          context: CONTEXTS.TEAM_RUN_ACTION_MENU,
          action: ACTIONS.CLICK,
          eventName: EVENT_NAMES.TEAM_RUN_COPY_SHORTHAND_MENU,
        });
      }

      if (itemClicked === ACTION_BUTTONS_NAME.COPY_SHORTHAND_DELTA.key) {
        extractCopyShortHandForSummaryRows(props, true, false, false, false, true);
        sendEvent({
          category: CATEGORIES.TEAM_RUN,
          context: CONTEXTS.TEAM_RUN_ACTION_MENU,
          action: ACTIONS.CLICK,
          eventName: EVENT_NAMES.TEAM_RUN_COPY_SHORTHAND_DELTA_MENU,
        });
        return;
      }

      if (itemClicked === ACTION_BUTTONS_NAME.COPY_SHORTHAND_NO_VOLS.key) {
        extractCopyShortHandForSummaryRows(props, false);
        sendEvent({
          category: CATEGORIES.TEAM_RUN,
          context: CONTEXTS.TEAM_RUN_ACTION_MENU,
          action: ACTIONS.CLICK,
          eventName: EVENT_NAMES.TEAM_RUN_COPY_SHORTHAND_NO_VOLS_MENU,
        });
        return;
      }

      if (itemClicked === ACTION_BUTTONS_NAME.COPY_SHORTHAND_NO_VOL_PREM.key) {
        extractCopyShortHandForSummaryRows(props, false, false, false, true);
        sendEvent({
          category: CATEGORIES.TEAM_RUN,
          context: CONTEXTS.TEAM_RUN_ACTION_MENU,
          action: ACTIONS.CLICK,
          eventName: EVENT_NAMES.TEAM_RUN_COPY_SHORTHAND_NO_VOL_PREM_MENU,
        });
        return;
      }

      if (itemClicked === ACTION_BUTTONS_NAME.ARCHIVE.key) {
        sendEvent({
          category: CATEGORIES.TEAM_RUN,
          context: CONTEXTS.TEAM_RUN_ACTION_MENU,
          action: ACTIONS.CLICK,
          eventName: EVENT_NAMES.TEAM_RUN_ARCHIVE_MENU,
        });
        const summaryIds = idsForMenuAction(data);
        const archiveRequest =
          summaryIds.length > 1
            ? archiveOptions(summaryIds)
            : archiveOption(summaryIds[0]);
        archiveRequest.then((res) => {
          toast(res?.data?.message, "success");
          triggerSingleAPIFunc(data.product_id);
        });
        return;
      }

      if (itemClicked === ACTION_BUTTONS_NAME.DETAILED_AUDIT_TRIAL.key) {
        sendEvent({
          category: CATEGORIES.TEAM_RUN,
          context: CONTEXTS.TEAM_RUN_ACTION_MENU,
          action: ACTIONS.CLICK,
          eventName: EVENT_NAMES.TEAM_RUN_DETAILED_AUDIT_TRAIL_MENU,
        });
        const preparePath = generatePath(ROUTES_PATH.AUDIT_TRAIL.auditDetails, {
          id: data.id,
        });
        navigate(preparePath);
        return;
      }

      if (itemClicked === ACTION_BUTTONS_NAME.PULL_TO_PRICER.key) {
        handlePullToPricer(true, data);
        return;
      }
      if (itemClicked === ACTION_BUTTONS_NAME.BLAST.key) {
        if (!canViewChat) return;
        sendEvent({
          category: CATEGORIES.TEAM_RUN,
          context: CONTEXTS.TEAM_RUN_ACTION_MENU,
          action: ACTIONS.CLICK,
          eventName: EVENT_NAMES.TEAM_RUN_BLAST_MENU,
        });
        const commodityName =
          data?.product ?? data?.commodity ?? data?.product_title ?? "";
        const messageBody = data?.copy_shorthand ?? "";
        setBlastPopupData({
          isOpen: true,
          commodityName,
          messageBody,
        });
        return;
      }
      if (itemClicked === ACTION_BUTTONS_NAME.ADDITIONAL_DATA.key) {
        sendEvent({
          category: CATEGORIES.TEAM_RUN,
          context: CONTEXTS.TEAM_RUN_ACTION_MENU,
          action: ACTIONS.CLICK,
          eventName: EVENT_NAMES.TEAM_RUN_ADDITIONAL_DATA_MENU,
        });
        let teamRun_data = {
          isAdditionalDataItemClicked: true,
          isOpen: true,
          data: props?.data ? props.data : props.node?.aggData,
        };

        setAdditionalPopupData(teamRun_data);
        return;
      }

      if (itemClicked === ACTION_BUTTONS_NAME.TRADE.key) {
        sendEvent({
          category: CATEGORIES.TEAM_RUN,
          context: CONTEXTS.TEAM_RUN_ACTION_MENU,
          action: ACTIONS.CLICK,
          eventName: EVENT_NAMES.TEAM_RUN_TRADE_MENU,
        });
        let teamRun_data = {
          isTradeItemClicked: true,
          data: props.data,
        };
        setTradePopupData(teamRun_data);
        return;
      }

      if (itemClicked === ACTION_BUTTONS_NAME.UPDATE_BID_ASK.key) {
        sendEvent({
          category: CATEGORIES.TEAM_RUN,
          context: CONTEXTS.TEAM_RUN_ACTION_MENU,
          action: ACTIONS.CLICK,
          eventName: EVENT_NAMES.TEAM_RUN_UPDATE_BID_ASK_MENU,
        });
        setDataForBidAndAskPopup();

        return;
      }

      if (itemClicked === ACTION_BUTTONS_NAME.DUPLICATE_AND_MAKE_LIVE.key) {
        await handleDuplicateTeamRunLive("make", data);
        return;
      }

      if (itemClicked === ACTION_BUTTONS_NAME.DUPLICATE_AND_REMOVE_LIVE.key) {
        await handleDuplicateTeamRunLive("remove", data);
        return;
      }

      if (itemClicked === ACTION_BUTTONS_NAME.UPDATE_OPTION.key) {
        return;
      }

      if (itemClicked === ACTION_BUTTONS_NAME.PUSH_OPTION.key) {
        return;
      }

      await handleMenuItemClickPartTwo(itemClicked, data);
      setTimeout(() => setMenuItemsClicked(""), 0);
    },
    [
      rowData,
      selectedRows,
      colorArray,
      selectedRowsLength,
      canViewChat,
      idsForMenuAction,
    ]
  );

  const handlePullToPricer = (isMenu, dataOverride) => {
    const dataToUse = dataOverride ?? rowData;
    const ids = isMenu
      ? idsForMenuAction(dataToUse)
      : [dataToUse.summary_id];
    handlePullToPricerClickTeamRun(ids).then((res) => {
      toast(res?.data?.message, "success");
    });
    sendEvent({
      category: CATEGORIES.TEAM_RUN,
      context: isMenu ? CONTEXTS.TEAM_RUN_ACTION_MENU : CONTEXTS.TEAM_RUN,
      action: ACTIONS.CLICK,
      component: isMenu
        ? COMPONENT_NAMES.MENU_BUTTON
        : COMPONENT_NAMES.ICON_BUTTON,
      eventName: isMenu
        ? EVENT_NAMES.TEAM_RUN_PULL_TO_PRICER_MENU
        : EVENT_NAMES.TEAM_RUN_PULL_TO_PRICER_ICON,
    });
  };
  // const handleMenuItemClicked = useCallback((key, value) => {
  //   setMenuItemsClicked({ ...menuItemsClicked, [key]: value });
  // }, []);

  const showDropDown = () => {
    return (
      <Dropdown
        id="team-run-action-column-dropdown"
        className={`action-buttons__dropdown button-icon ${
          !dark_Theme && "button-light-theme"
        }`}
        trigger={["click", "contextMenu"]}
        overlay={
          <Menu
            id="team-run-action-column-menu"
            onClick={({ key }) => handleMenuItemClick(key)}
            key="action-buttons__menu-items_MENU"
            items={
              (
                !menuItemsClicked && !selectedRowsLength
                  ? returnSelectedDropDown()
                  : menuItemsData
              )
                ?.filter(
                  (item) =>
                    canViewChat || item.key !== ACTION_BUTTONS_NAME.BLAST.key
                )
                .sort((a, b) => a.index - b.index)
            }
            theme={dark_Theme ? "dark" : "light"}
          />
        }
        overlayClassName={dark_Theme && "menu-dropdown-dark"}
      >
        <Space>
          <MenuOutlined id="team-run-menu-items" />
        </Space>
      </Dropdown>
    );
  };

  return (
    <>
      <div className="action-buttons__container action-button_container">
        {/*Show CopyShortHand*/}
        <CopyOutlined
          id="copy-shorthand"
          onClick={() => {
            sendEvent({
              category: CATEGORIES.TEAM_RUN,
              context: CONTEXTS.TEAM_RUN,
              action: ACTIONS.CLICK,
              component: COMPONENT_NAMES.ICON_BUTTON,
              eventName: EVENT_NAMES.TEAM_RUN_COPY_SHORTHAND_ICON,
            });
            handleCopyShortHand(rowData.copy_shorthand);
          }}
          className={classnames("button-icon", {
            "button-light-theme": !dark_Theme,
          })}
        />

        {/*Show Pull To Pricer*/}
        <ImportOutlined
          id="pull-to-pricer"
          onClick={() => {
            handlePullToPricer(false);
          }}
          className={classnames("button-icon", {
            "button-light-theme": !dark_Theme,
          })}
        />

        <SwapOutlined
          rotate={90}
          id="update-bid-ask"
          onClick={() => {
            sendEvent({
              category: CATEGORIES.TEAM_RUN,
              context: CONTEXTS.TEAM_RUN,
              action: ACTIONS.CLICK,
              component: COMPONENT_NAMES.ICON_BUTTON,
              eventName: EVENT_NAMES.TEAM_RUN_UPDATE_BID_ASK_ICON,
            });
            setDataForBidAndAskPopup();
          }}
          className={classnames("button-icon", {
            "button-light-theme": !dark_Theme,
          })}
        />
        {/* Show Menu Item When Menu Icon Clicked */}
        {showDropDown()}
      </div>
    </>
  );
};

export default ActionColumn;
